// extracted by mini-css-extract-plugin
export default {"header_dg_wrapper":"cell_header_dg_wrapper__oJhcH","header_dgs_container":"cell_header_dgs_container__zY9u+"};